const cardItems = [
  {
    title: '香蕉视频热门影视排行榜',
    desc: '本月香蕉视频平台热播影视TOP 10，涵盖动作、喜剧、悬疑等多元类型，观影指南一手掌握。',
    image: 'https://readdy.ai/api/search-image?query=Movie%20ranking%20chart%20concept%20with%20film%20posters%20collage%20on%20dark%20background%2C%20warm%20coral%20and%20golden%20accent%20colors%2C%20elegant%20top%2010%20list%20design%2C%20cinematic%20aesthetic%2C%20professional%20editorial%20style&width=600&height=400&seq=card-img-01&orientation=landscape',
    date: '2026-07-30',
    tag: '影视排行',
  },
  {
    title: '红桃视频新上自制内容一览',
    desc: '红桃视频近期推出的多部原创综艺及纪录片，品质内容获用户广泛好评，持续丰富平台内容生态。',
    image: 'https://readdy.ai/api/search-image?query=TV%20production%20studio%20with%20professional%20lighting%20equipment%20and%20warm%20ambient%20glow%2C%20creative%20workspace%20aesthetic%2C%20modern%20entertainment%20industry%20vibe%2C%20golden%20and%20coral%20color%20scheme&width=600&height=400&seq=card-img-02&orientation=landscape',
    date: '2026-07-28',
    tag: '自制内容',
  },
  {
    title: '91视频创作者生态观察',
    desc: '91视频平台UGC创作者活跃度持续上升，多元内容生态正在形成，优质原创作者不断涌现。',
    image: 'https://readdy.ai/api/search-image?query=Creative%20content%20creator%20community%20concept%20with%20diverse%20people%20silhouettes%20and%20glowing%20connection%20lines%2C%20warm%20gradient%20background%2C%20modern%20digital%20community%20aesthetic%2C%20inspiring%20atmosphere&width=600&height=400&seq=card-img-03&orientation=landscape',
    date: '2026-07-26',
    tag: '创作生态',
  },
  {
    title: '西瓜视频算法推荐揭秘',
    desc: '了解西瓜视频如何通过智能推荐算法为用户匹配个性化内容，提升视频发现效率与观看体验。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20AI%20algorithm%20visualization%20with%20flowing%20data%20lines%20and%20nodes%2C%20warm%20coral%20and%20amber%20gradient%2C%20modern%20tech%20aesthetic%2C%20geometric%20patterns%2C%20clean%20minimal%20design%2C%20soft%20glow%20effects&width=600&height=400&seq=card-img-04&orientation=landscape',
    date: '2026-07-24',
    tag: '技术解析',
  },
  {
    title: '蜜桃视频画质升级全解析',
    desc: '蜜桃视频最新播放器支持4K超清，从编码技术到带宽优化，全面提升在线视频观看体验。',
    image: 'https://readdy.ai/api/search-image?query=High%20definition%20video%20quality%20concept%20with%20crystal%20clear%20screen%20display%20and%20light%20reflections%2C%20modern%20tech%20aesthetic%2C%20warm%20ambient%20lighting%2C%204K%20resolution%20representation%2C%20clean%20minimalist%20style&width=600&height=400&seq=card-img-05&orientation=landscape',
    date: '2026-07-22',
    tag: '画质升级',
  },
  {
    title: '樱花视频字幕组精选指南',
    desc: '从日剧到日影，樱花视频字幕组精译作品推荐，了解高质量翻译背后的团队与流程。',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20text%20and%20subtitles%20aesthetic%20with%20cherry%20blossom%20elements%2C%20elegant%20typography%20on%20soft%20pink%20and%20cream%20background%2C%20minimalist%20Japanese%20design%20influence%2C%20warm%20delicate%20lighting&width=600&height=400&seq=card-img-06&orientation=landscape',
    date: '2026-07-20',
    tag: '字幕精选',
  },
  {
    title: '糖豆视频轻娱乐模式分析',
    desc: '糖豆视频以轻量化短视频切入市场，碎片化娱乐模式如何吸引大量用户，流量趋势解读。',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20lightweight%20mobile%20entertainment%20concept%20with%20floating%20playful%20elements%2C%20candy%20colored%20gradients%20in%20warm%20tones%2C%20fun%20vibrant%20aesthetic%2C%20modern%20social%20media%20style%2C%20joyful%20composition&width=600&height=400&seq=card-img-07&orientation=landscape',
    date: '2026-07-18',
    tag: '模式分析',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">精选内容</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            深度解读各大视频平台动态与行业趋势，掌握最新视频资讯
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <article
              key={i}
              className={`group rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 font-medium">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <span className="text-xs text-foreground-400">{item.date}</span>
                <h3 className="mt-1 text-sm font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}